import { fetcher } from "@website/fetcher/fetcher";
import {
  SendOtpBodyType,
  SendOtpResponseType
} from "@website/widget/login/services/send-otp/send-otp.types";

export const SendOtpUrl = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/auth/inquiry`;

export const SendOtpService = (
  body: SendOtpBodyType
): Promise<SendOtpResponseType> =>
  fetcher({
    url: SendOtpUrl,
    method: "POST",
    data: body
  }).then(({ data }) => data);
